export default {
  title: 'Criar nova palavra-passe',
  description: 'Crie uma nova palavra-passe para a sua conta.',
  form: {
    new_password: {
      label: 'Nova palavra-passe',
      placeholder: 'Introduza a palavra-passe',
      requirements: 'A sua palavra-passe deve conter 8 caracteres, uma letra maiúscula e um número',
    },
    confirm_password: {
      label: 'Confirmação da nova palavra-passe',
      placeholder: 'Confirmar palavra-passe',
    },
    error_messages: {
      missing_info: 'Informação em falta',
    },
  },
  buttons: {
    update_password: 'Atualizar palavra-passe',
  },
};
